import { render, staticRenderFns } from "./OwnpadSettingsForm.vue?vue&type=template&id=1e8d5963&scoped=true"
import script from "./OwnpadSettingsForm.vue?vue&type=script&lang=js"
export * from "./OwnpadSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./OwnpadSettingsForm.vue?vue&type=style&index=0&id=1e8d5963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d5963",
  null
  
)

export default component.exports